import {SignatureType, team, TeamMemberSlug} from '@/content/team'
import {Jurisdiction} from '@/utils/countries/constants'

export const getDefaultLawyerByCountry = (country: string | string[] | null) =>
  (Array.isArray(country) && country.includes(Jurisdiction.US)) || country === Jurisdiction.US
    ? team[TeamMemberSlug.marekKrizka]
    : team[TeamMemberSlug.igorDemcak]

// Signatures render at a fixed CSS height, so next/image is given that display size (it then
// serves 1x/2x versions of it) rather than the source dimensions.
export const getSignatureSize = ({width, height}: SignatureType, displayHeight: number) => ({
  width: Math.round((width / height) * displayHeight),
  height: displayHeight,
})
